import React, {useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const TabButton = ({
                     label,
                     onClick,
                     isActive = false,
                     disabled
                   }) => {
  return (
    <div
      className={classnames(styles.tabButton, {
        [styles.active]: isActive && !disabled,
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
    >
      {label}
    </div>
  );
};

const TabsHolder = ({
                      tabs,
                      defaultTab = 0,
                      showLastTabDivider = false
                    }) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);

  const mapTabButtons = () => {
    return tabs.map((tab, index) => {
      const {title, disabled} = tab;
      const handleClick = () => !disabled && setCurrentTab(index);
      const isActive = index === currentTab;
      const isLastItem = index === tabs.length - 1;

      return (
        <React.Fragment key={index}>
          {isLastItem && showLastTabDivider && <div className={styles.divideLine} /> }
          <TabButton
            label={title}
            key={index}
            onClick={handleClick}
            isActive={isActive}
            disabled={disabled}
          />
        </React.Fragment>
      );
    });
  };

  const getCurrentTabContent = () => {
    return tabs[currentTab].content;
  };

  return (
    <div className={styles.tabsHolder}>
      <div className={styles.tabsButtons}>
        {mapTabButtons()}
      </div>
      {getCurrentTabContent()}
    </div>
  );
};

TabsHolder.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  defaultTab: PropTypes.number,
  showLastTabDivider: PropTypes.bool,
};

export default TabsHolder;
